import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { ApplicationState } from "../store";
import * as ConfigurationActions from "../store/configurationService/actions";

interface IProps {
    location: any;
}

type ISocialMediaProps = IProps;

const Logout: React.FunctionComponent<ISocialMediaProps> = (props) => {
    const history = useHistory();
    const dispatch = useDispatch();
    const routeLoading = useSelector((state: ApplicationState) => state.configurationState && (state.configurationState.loading || false));
    const isMalwareBytesPartner = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.partnerId
            ? state.configurationState.configuration.partnerConfig.partnerId === 2664
                ? true
                : false
            : false
    );

    useEffect(() => {
        if (isMalwareBytesPartner) {
            window.location.href = 'https://my.malwarebytes.com/login';
        } else {
            history.push({
                pathname: "/Login",
                state: { from: "logout" },
            });
        }
    }, []);

    useEffect(() => {
        if (routeLoading) {
            dispatch(ConfigurationActions.actionCreators.setRouteLoading(false));
        }
    }, [dispatch, routeLoading]);

    return (
        <div role="row" className="data-row row">
            <div className="box loading" style={{ width: "100%" }}></div>
        </div>
    );
};

export default Logout;
